import React, { useState, useMemo } from 'react';
import { Row, Button, Input, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { Share2, Search, ChevronDown } from 'react-feather';
// Market Icon Import
import nielsen from '../../../assets/images/markets/nielsen.png';
import mintel from '../../../assets/images/markets/mintel.png';
import npd from '../../../assets/images/markets/npd.png';
import crunchbase from '../../../assets/images/markets/crunchbase.png';
import cxi from '../../../assets/images/markets/cxi.png';
import sapLogo from '../../../assets/images/markets/sap.png';
import integrationImages from '../../integration/images';

const MARKET_DATA = [
	{ name: 'NPD', logo: npd, category: 'Marketing', subject: 'NPD Inquiry' },
	{ name: 'Crunchbase', logo: crunchbase, category: 'Data', subject: 'Crunchbase Inquiry' },
	{ name: 'Mintel', logo: mintel, category: 'Marketing', subject: 'Mintel Inquiry' },
	{ name: 'Nielsen', logo: nielsen, category: 'Marketing', subject: 'Nielsen Inquiry' },
	{ name: 'Airtable', logo: integrationImages.airtable.logo, category: 'Data', subject: 'Airtable Inquiry' },
	{ name: 'Google Cloud', logo: integrationImages.google_cloud.logo, category: 'Data', subject: 'Google Cloud Inquiry' },
	{ name: 'IBM', logo: integrationImages.ibm.logo, category: 'Nutrition', subject: 'IBM Inquiry' },
	{ name: 'Odoo', logo: integrationImages.odoo.logo, category: 'Supply Chain', subject: 'Odoo Inquiry' },
	{ name: 'Microsoft Dynamics', logo: integrationImages.microsoft_dynamics.logo, category: 'Supply Chain', subject: 'Microsoft Dynamics Inquiry' },
	{ name: 'Oracle ERP', logo: integrationImages.oracle.logo, category: 'Supply Chain', subject: 'Oracle ERP Inquiry' },
	{ name: 'SAP', logo: sapLogo, category: 'Supply Chain', subject: 'SAP.io Marketplace Inquiry' },
	{ name: 'Shopify', logo: integrationImages.shopify.logo, category: 'Sustainability', subject: 'Shopify Inquiry' },
	{ name: 'Customerx.i', logo: cxi, category: 'Marketing', subject: 'Customerx.i Inquiry', comingSoon: true },
];

const CATEGORIES = ['All', 'Marketing', 'Supply Chain', 'Sustainability', 'Data', 'Nutrition', 'Cost'];

const Markets = () => {
	const [searchQuery, setSearchQuery] = useState('');
	const [selectedCategory, setSelectedCategory] = useState('All');
	const [dropdownOpen, setDropdownOpen] = useState(false);

	const toggleDropdown = () => setDropdownOpen((prevState) => !prevState);

	const filteredMarkets = useMemo(() => {
		return MARKET_DATA.filter((market) => {
			const matchesSearch = market.name.toLowerCase().includes(searchQuery.toLowerCase());
			const matchesCategory = selectedCategory === 'All' || market.category === selectedCategory;
			return matchesSearch && matchesCategory;
		});
	}, [searchQuery, selectedCategory]);

	return (
		<div className={'page-content container-fluid'} style={{ marginBottom: 35 }}>
			<div className="analytics-markets">
				<Row className="markets-intro">
					<h4 className={'mb-3'}>Connect your market research data to your innovation team.</h4>
					<p>
						Whether it's your own data or third-party data, find out more about our key partners and contact
						us to connect to other partners.
					</p>
				</Row>

				<div className="markets-filter-section">
					<div className="filter-top">
						<div className="search-container">
							<Search size={18} className="search-icon" />
							<Input
								type="text"
								placeholder="Search integrations..."
								value={searchQuery}
								onChange={(e) => setSearchQuery(e.target.value)}
								className="search-input"
							/>
						</div>
						<div className="category-dropdown-container">
							<Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
								<DropdownToggle className="category-dropdown-toggle">
									Category <ChevronDown size={16} />
								</DropdownToggle>
								<DropdownMenu>
									{CATEGORIES.map((cat) => (
										<DropdownItem key={cat} onClick={() => setSelectedCategory(cat)}>
											{cat}
										</DropdownItem>
									))}
								</DropdownMenu>
							</Dropdown>
						</div>
						<div className="integration-count">{filteredMarkets.length} integrations</div>
					</div>

					<div className="filter-tags">
						{CATEGORIES.map((cat) => (
							<button
								key={cat}
								className={`filter-tag ${selectedCategory === cat ? 'active' : ''}`}
								onClick={() => setSelectedCategory(cat)}
							>
								{cat}
							</button>
						))}
					</div>
				</div>

				<Row className="markets-grid">
					{filteredMarkets.map((market, index) => (
						<div key={index} className={'market-connection'}>
							<span>
								<img src={market.logo} alt={market.name} />
							</span>
							{market.comingSoon ? (
								<Button disabled={true} color="secondary" outline className="mt-4 color-battleship-grey">
									<Share2 className="mr-2 color-battleship-grey" size={17} />
									Coming Soon
								</Button>
							) : (
								<a href={`mailto:sales@journeyfoods.com?subject=${market.subject}`}>
									<Button color="secondary" outline className="mt-4 color-battleship-grey">
										<Share2 className="mr-2 color-battleship-grey" size={17} />
										Request
									</Button>
								</a>
							)}
						</div>
					))}
				</Row>
			</div>
		</div>
	);
};

export default Markets;